var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "XMLID_1840_",
    width: 51.341,
    height: 51.341,
    viewBox: "0 0 51.341 51.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ecac58}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1021_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1068_",
    d: "M49.36 64.608a1 1 0 0 0-.415-1.356A15.726 15.726 0 0 0 31.6 64.983l-1.62-1.62 2.646-2.646a1 1 0 0 0-1.415-1.417l-2.646 2.646-6.456-6.456a14.019 14.019 0 0 0 1.139-14.96 1 1 0 1 0-1.771.941 11.942 11.942 0 0 1-.8 12.582L16.42 49.8a2.461 2.461 0 0 0-4.051.893L.154 84.017a2.465 2.465 0 0 0 2.3 3.311 2.489 2.489 0 0 0 .857-.154l33.324-12.215a2.461 2.461 0 0 0 .893-4.05l-4.5-4.5A13.718 13.718 0 0 1 48 65.023a1 1 0 0 0 1.356-.415zM15.971 80.4L6.93 71.357l2.505-6.834 13.37 13.37zm-4.9 1.8l-5.937-5.943 1.036-2.825 7.73 7.726zm-8.45 3.1a.455.455 0 0 1-.584-.584l2.337-6.375L9 82.954zm33.612-12.554a.443.443 0 0 1-.288.329l-6.165 2.26-5.7-5.7a1 1 0 1 0-1.418 1.418l5.043 5.047-2.825 1.035L10.2 62.447l1.035-2.825 5.046 5.046a1 1 0 1 0 1.419-1.417l-5.7-5.7 2.26-6.165a.443.443 0 0 1 .33-.288.484.484 0 0 1 .1-.011.436.436 0 0 1 .316.134L36.11 72.326a.443.443 0 0 1 .123.42z",
    className: "cls-1",
    transform: "translate(0 -35.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1441_",
    d: "M292.6 16.485a1 1 0 0 0 1-1 1.525 1.525 0 0 1 1.523-1.523 3.532 3.532 0 0 0 3.528-3.528 1 1 0 1 0-2.005 0 1.525 1.525 0 0 1-1.523 1.523 3.533 3.533 0 0 0-3.529 3.528 1 1 0 0 0 1.006 1z",
    className: "cls-1",
    transform: "translate(-262.357 -8.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1462_",
    d: "M381.322 108.8a3.648 3.648 0 0 0 3.644-3.644 1.64 1.64 0 0 1 1.639-1.639 1 1 0 1 0 0-2.005 3.648 3.648 0 0 0-3.644 3.644 1.641 1.641 0 0 1-1.639 1.639 1 1 0 0 0 0 2.005z",
    className: "cls-1",
    transform: "translate(-342.183 -91.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1489_",
    d: "M448 164.694a3.209 3.209 0 1 0 3.209-3.209 3.212 3.212 0 0 0-3.209 3.209zm3.209-1.2a1.2 1.2 0 1 1-1.2 1.2 1.2 1.2 0 0 1 1.202-1.204z",
    className: "cls-1",
    transform: "translate(-403.079 -145.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1502_",
    d: "M286.319 112.272a3.209 3.209 0 1 0-3.209-3.209 3.212 3.212 0 0 0 3.209 3.209zm0-4.412a1.2 1.2 0 1 1-1.2 1.2 1.2 1.2 0 0 1 1.2-1.201z",
    className: "cls-1",
    transform: "translate(-254.721 -95.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1619_",
    d: "M99.211 6.418A3.209 3.209 0 1 0 96 3.209a3.212 3.212 0 0 0 3.211 3.209zm0-4.412a1.2 1.2 0 1 1-1.2 1.2 1.2 1.2 0 0 1 1.2-1.201z",
    className: "cls-1",
    transform: "translate(-86.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1620_",
    d: "M437.145 348.423a1 1 0 1 0-1.418 1.418l.945.945a1 1 0 0 0 1.418-1.418z",
    className: "cls-1",
    transform: "translate(-391.77 -313.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1659_",
    d: "M484.285 395.563a1 1 0 1 0-1.418 1.418l.945.945a1 1 0 0 0 1.418-1.418z",
    className: "cls-1",
    transform: "translate(-434.183 -355.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1690_",
    d: "M483.812 348.423l-.945.945a1 1 0 1 0 1.418 1.418l.945-.945a1 1 0 0 0-1.418-1.418z",
    className: "cls-1",
    transform: "translate(-434.183 -313.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1712_",
    d: "M436.672 395.563l-.945.945a1 1 0 1 0 1.418 1.418l.945-.945a1 1 0 0 0-1.418-1.418z",
    className: "cls-1",
    transform: "translate(-391.77 -355.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1715_",
    d: "M483.576 2.951a1 1 0 0 0 .709-.294l.945-.945a1 1 0 0 0-1.418-1.418l-.945.945a1 1 0 0 0 .709 1.712z",
    className: "cls-1",
    transform: "translate(-434.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1747_",
    d: "M436.435 50.09a1 1 0 0 0 .709-.294l.945-.945a1 1 0 0 0-1.418-1.418l-.945.945a1 1 0 0 0 .709 1.712z",
    className: "cls-1",
    transform: "translate(-391.769 -42.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1750_",
    d: "M484.285 47.434a1 1 0 1 0-1.418 1.418l.945.945a1 1 0 0 0 1.418-1.418z",
    className: "cls-1",
    transform: "translate(-434.183 -42.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1751_",
    d: "M436.671 2.657a1 1 0 0 0 1.418-1.418l-.945-.945a1 1 0 0 0-1.418 1.418z",
    className: "cls-1",
    transform: "translate(-391.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1755_",
    d: "M192.224 300.78a1 1 0 1 0 .709.294 1.01 1.01 0 0 0-.709-.294z",
    className: "cls-1",
    transform: "translate(-172.046 -270.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1756_",
    d: "M337.96 193.981l-.727.727a1 1 0 1 0 1.418 1.418l.727-.727a1 1 0 0 0-1.418-1.418z",
    className: "cls-1",
    transform: "translate(-303.153 -174.265)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParty);
export default __webpack_public_path__ + "static/media/icon_party.68d41a839fccccc5bca03861fa083acc.svg";
export { ForwardRef as ReactComponent };